import { OfficeTypeMap } from "../CMS/schema"
import { PracticeBillingAddress, PracticeStatus } from "../Practice/schema"
import { ContactInfo, LiabilityInsurance } from "../Practices/schema"
import { Provider } from "../Provider/schema"
import { PracticeTypeDisplayId } from "../enums/displayId.enum"

export interface PublicPhone {
  id: string
  number: string
  locationPhoneTypeDisplayId: string
}

export interface PublicEmail {
  id: string
  address: string
  locationEmailTypeDisplayId: string
}

export const enum LocationPhotoTypeEnum {
  Home = "home",
  General = "general",
  Animal = "animal",
}

export interface PublicLocationPhoto {
  id: string
  name?: string
  fileName: string
  description?: string
  locationPhotoTypeDisplayId: LocationPhotoTypeEnum
  // Carried inline only, conditionally, when the photo was hydrated from a search-driven flow.
  thumbnailBase64?: string
}

export interface PublicLocation {
  id: string
  line1: string
  line2: string
  city: string
  stateOrTerritory: string
  postalCode: string
  fax: string
  isPrimary: boolean
  isAdaAccessible: boolean
  officeRequirementsCertified: boolean
  locationTypeDisplayId: keyof OfficeTypeMap
  phones: PublicPhone[]
  emails: PublicEmail[]
  locationPhotos: PublicLocationPhoto[]
}

export interface PublicPractice {
  id: string
  name: string
  status: PracticeStatus
  isVisible: boolean
  websiteUrl?: string
  overview?: string
  logoImageUrl?: string
  authReleaseRequired?: boolean
  affiliateSince: string
  locations: PublicLocation[]
  liabilityInsurances: LiabilityInsurance[]
  billingAddress: PracticeBillingAddress | null
  contactInfo: ContactInfo | null
  typeId?: PracticeTypeDisplayId
  isPracticeAgreementStale?: boolean
  isKnoxKeeneStale?: boolean
  hasOnlineServicesInCalifornia?: boolean
  isPracticeAgreementSigned?: boolean
  isKnoxKeeneSigned?: boolean
}

export interface PublicProfilePractice extends PublicPractice {
  tags: string[]
  providersInfo: Provider[]
  typeId: PracticeTypeDisplayId
  authReleaseRequired?: boolean
  liabilityInsurances: LiabilityInsurance[]
}
